 <template>
  <div class="finance">
    <el-row :gutter="24" class="stats-row">
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <div class="stat-icon blue"><i class="el-icon-money" /></div>
          <div class="stat-info">
            <p class="stat-label">平台总流水</p>
            <h3 class="stat-value">{{ formatWan(financeStats.totalFlow) }}</h3>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <div class="stat-icon red"><i class="el-icon-date" /></div>
          <div class="stat-info">
            <p class="stat-label">本月流水</p>
            <h3 class="stat-value">{{ formatWan(financeStats.monthFlow) }}</h3>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <div class="stat-icon orange"><i class="el-icon-receiving" /></div>
          <div class="stat-info">
            <p class="stat-label">手续费总收入</p>
            <h3 class="stat-value">{{ formatWan(financeStats.totalFee) }}</h3>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <div class="stat-icon green"><i class="el-icon-pie-chart" /></div>
          <div class="stat-info">
            <p class="stat-label">分红总支出</p>
            <h3 class="stat-value">{{ formatWan(financeStats.totalDividend) }}</h3>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="special-card">
      <div slot="header" class="card-header"><span>📊 本月专项统计</span></div>
      <el-row :gutter="16">
        <el-col :span="4">
          <div class="special-item">
            <div class="special-icon blue"><i class="el-icon-coin" /></div>
            <div class="special-info">
              <div class="special-value">¥{{ (financeStats.monthReserveReward || 0).toLocaleString() }}</div>
              <div class="special-label">预留奖励</div>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="special-item special-item-border">
            <div class="special-icon orange"><i class="el-icon-goods" /></div>
            <div class="special-info">
              <div class="special-value">¥{{ (financeStats.monthInviterReward || 0).toLocaleString() }}</div>
              <div class="special-label">推广佣金奖励</div>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="special-item special-item-border">
            <div class="special-icon red"><i class="el-icon-receiving" /></div>
            <div class="special-info">
              <div class="special-value">¥{{ (financeStats.monthPlatformIncome || 0).toLocaleString() }}</div>
              <div class="special-label">手续费收入</div>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="special-item special-item-border">
            <div class="special-icon purple"><i class="el-icon-connection" /></div>
            <div class="special-info">
              <div class="special-value">¥{{ (financeStats.monthBranchInviterReward || 0).toLocaleString() }}</div>
              <div class="special-label">分身商邀请人收入</div>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="special-item">
            <div class="special-icon green"><i class="el-icon-pie-chart" /></div>
            <div class="special-info">
              <div class="special-value">¥{{ (financeStats.monthDividend || 0).toLocaleString() }}</div>
              <div class="special-label">业务经理团队分红</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card shadow="never" class="chart-card">
      <div slot="header" class="card-header"><span>近6个月平台流水趋势</span></div>
      <div ref="financeChart" style="height: 280px;"></div>
    </el-card>

    <el-card shadow="never" class="filter-card">
      <el-row :gutter="16" class="filter-row">
        <el-col :span="4">
          <label class="filter-label">起始日期</label>
          <el-date-picker v-model="flowFilter.startDate" type="date" placeholder="选择日期" size="small" style="width: 100%;" value-format="yyyy-MM-dd" />
        </el-col>
        <el-col :span="4">
          <label class="filter-label">结束日期</label>
          <el-date-picker v-model="flowFilter.endDate" type="date" placeholder="选择日期" size="small" style="width: 100%;" value-format="yyyy-MM-dd" />
        </el-col>
        <el-col :span="4">
          <label class="filter-label">关联分身</label>
          <el-select v-model="flowFilter.branchId" placeholder="全部" size="small" style="width: 100%;" clearable>
            <el-option v-for="b in branchOptions" :key="b.id" :label="b.name" :value="b.id" />
          </el-select>
        </el-col>
        <el-col :span="8">
          <label class="filter-label">&nbsp;</label>
          <div class="filter-btns">
            <el-button type="danger" size="small" @click="handleQuery">查询</el-button>
            <el-button size="small" @click="handleExport">导出报表</el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card shadow="never" class="table-card">
      <div slot="header" class="card-header"><span>流水明细</span></div>
      <el-table :data="flowList" style="width: 100%;" border stripe v-loading="flowLoading">
        <el-table-column prop="id" label="流水ID" width="160">
          <template slot-scope="scope"><code>{{ scope.row.id }}</code></template>
        </el-table-column>
        <el-table-column label="时间" width="180">
          <template slot-scope="scope">{{ scope.row.time | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="类型" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type_code === 'order' ? '' : scope.row.type_code === 'fee' ? 'danger' : scope.row.type_code === 'dividend' ? 'warning' : 'info'" size="small">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="120" align="right">
          <template slot-scope="scope">
            <span :class="scope.row.amount > 0 ? 'amount-plus' : 'amount-minus'">{{ formatAmount(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="related" label="关联分身/订单" min-width="200" />
        <el-table-column label="账户余额变动" width="120" align="right">
          <template slot-scope="scope">
            <span :class="scope.row.balanceChange > 0 ? 'amount-plus' : 'amount-minus'">{{ formatAmount(scope.row.balanceChange) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" />
      </el-table>

      <div class="table-footer">
        <div class="summary">
          <span>本页收入合计：<strong class="green">¥{{ flowSummary.income.toLocaleString() }}</strong></span>
          <span>本页支出合计：<strong class="red">¥{{ flowSummary.expense.toLocaleString() }}</strong></span>
          <el-divider direction="vertical" />
          <span>本页净额：<strong>¥{{ flowSummary.net.toLocaleString() }}</strong></span>
        </div>
        <div class="pagination-info">
          <span>共 {{ flowTotal }} 条，每页 {{ flowLimit }} 条</span>
          <el-pagination background layout="prev, pager, next" :total="flowTotal" :page-size="flowLimit" :current-page.sync="flowPage" @current-change="fetchFlowList" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getFinance, getFlowList, getFinanceBranches } from '@/api'

export default {
  name: 'Finance',
  data() {
    return {
      flowFilter: { startDate: '', endDate: '', branchId: '' },
      flowList: [], flowTotal: 0, flowPage: 1, flowLimit: 10, flowLoading: false,
      flowSummary: { income: 0, expense: 0, net: 0 },
      financeStats: { totalFlow: 0, monthFlow: 0, totalFee: 0, totalDividend: 0, monthReserveReward: 0, monthInviterReward: 0, monthPlatformIncome: 0, monthBranchInviterReward: 0, monthDividend: 0 },
      sixMonthData: [],
      branchOptions: [],
      chart: null
    }
  },
  mounted() {
    this.fetchFinanceData()
    this.fetchFlowList()
    this.fetchBranches()
  },
  beforeDestroy() {
    if (this.chart) this.chart.dispose()
  },
  methods: {
    formatWan(num) {
      if (num >= 10000) return (num / 10000).toFixed(1) + ' 万元'
      return num.toLocaleString() + ' 元'
    },
    formatAmount(amount) {
      return amount > 0 ? `+${amount.toLocaleString()}` : `${amount.toLocaleString()}`
    },
    fetchFinanceData() {
      getFinance().then(res => {
        if (res.stats) this.financeStats = res.stats
        if (res.sixMonthData) {
          this.sixMonthData = res.sixMonthData
          this.initChart()
        }
      }).catch(() => {})
    },
    fetchFlowList() {
      this.flowLoading = true
      const params = { page: this.flowPage, limit: this.flowLimit }
      if (this.flowFilter.startDate) params.startDate = this.flowFilter.startDate
      if (this.flowFilter.endDate) params.endDate = this.flowFilter.endDate
      if (this.flowFilter.branchId) params.branch_id = this.flowFilter.branchId

      getFlowList(params).then(res => {
        this.flowList = res.list || []
        this.flowTotal = res.total || 0
        if (res.summary) this.flowSummary = res.summary
      }).catch(() => {
        this.$message.error('获取流水失败')
      }).finally(() => { this.flowLoading = false })
    },
    fetchBranches() {
      getFinanceBranches().then(res => {
        this.branchOptions = res || []
      }).catch(() => {})
    },
    initChart() {
      const echarts = require('echarts')
      if (this.chart) this.chart.dispose()
      this.chart = echarts.init(this.$refs.financeChart)

      const months = this.sixMonthData.map(d => d.month)
      const orderFlow = this.sixMonthData.map(d => d.orderFlow)
      const dividend = this.sixMonthData.map(d => d.dividend)
      const totalFlow = this.sixMonthData.map(d => d.orderFlow + d.dividend)

      this.chart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['流水总额', '订单流水', '分红支出'], bottom: 0 },
        grid: { left: '3%', right: '4%', bottom: '15%', containLabel: true },
        xAxis: { type: 'category', data: months.length ? months : ['2026-01', '2026-02', '2026-03', '2026-04', '2026-05', '2026-06'] },
        yAxis: { type: 'value', name: '金额' },
        series: [
          { name: '流水总额', type: 'line', data: totalFlow.length ? totalFlow : [180, 210, 195, 230, 250, 286], smooth: true, itemStyle: { color: '#E4393C' }, areaStyle: { color: 'rgba(228,57,60,0.1)' } },
          { name: '订单流水', type: 'bar', data: orderFlow.length ? orderFlow : [120, 150, 130, 170, 180, 200], itemStyle: { color: '#409EFF' } },
          { name: '分红支出', type: 'bar', data: dividend.length ? dividend : [60, 60, 65, 60, 70, 86], itemStyle: { color: '#e6a23c' } }
        ]
      })
      window.addEventListener('resize', () => { this.chart && this.chart.resize() })
    },
    handleQuery() {
      this.flowPage = 1
      this.fetchFlowList()
      this.$message.success('查询完成')
    },
    handleExport() { this.$message.success('正在导出报表，请稍候...') }
  }
}
</script>

<style scoped>
.stats-row { margin-bottom: 24px; }
.stat-card { border-radius: 8px; display: flex; align-items: center; gap: 16px; }
.stat-icon { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
.stat-icon.blue { background: #ecf5ff; color: #409EFF; }
.stat-icon.red { background: #fef0f0; color: #E4393C; }
.stat-icon.orange { background: #fdf6ec; color: #e6a23c; }
.stat-icon.green { background: #f0f9eb; color: #67c23a; }
.stat-icon.purple { background: #f4ecfe; color: #9c27b0; }
.stat-info { flex: 1; min-width: 0; }
.stat-label { font-size: 13px; color: #909399; margin: 0 0 4px; }
.stat-value { font-size: 22px; font-weight: bold; margin: 0; color: #303133; }
.special-card { border-radius: 8px; margin-bottom: 24px; }
.card-header { font-weight: bold; color: #303133; }
.special-item { display: flex; align-items: center; padding: 12px 16px; gap: 12px; }
.special-item-border { border-left: 1px solid #ebeef5; border-right: 1px solid #ebeef5; }
.special-icon { width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
.special-icon.blue { background: #ecf5ff; color: #409EFF; }
.special-icon.orange { background: #fdf6ec; color: #e6a23c; }
.special-icon.green { background: #f0f9eb; color: #67c23a; }
.special-icon.purple { background: #f4ecfe; color: #9c27b0; }
.special-value { font-size: 18px; font-weight: bold; color: #303133; }
.special-label { font-size: 12px; color: #909399; margin-top: 2px; }
.chart-card { border-radius: 8px; margin-bottom: 24px; }
.filter-card { border-radius: 8px; margin-bottom: 24px; }
.filter-row { align-items: flex-end; }
.filter-label { display: block; font-size: 13px; color: #606266; margin-bottom: 6px; font-weight: 500; }
.filter-btns { display: flex; gap: 12px; }
.table-card { border-radius: 8px; }
.amount-plus { color: #67c23a; font-weight: bold; }
.amount-minus { color: #E4393C; font-weight: bold; }
.table-footer { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
.summary { display: flex; align-items: center; gap: 16px; }
.summary .green { color: #67c23a; }
.summary .red { color: #E4393C; }
.pagination-info { display: flex; align-items: center; gap: 12px; }
</style>
